import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-binocular-icon',
  templateUrl: './general-binocular.component.html'
})
export class GeneralBinocularComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
